<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import config from "../../config.js";
import { errorAlert } from "../../plugins/alert";
import { initialOrderPackData,setLastAssignmentDate } from "../..//plugins/order";
import { deepCopy } from "../..//plugins/utility";
import CustomList from "../../compositions/CustomList.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import TextBox from "../../compositions/TextBox.vue";
import ModalDialog from "../../compositions/ModalDialog.vue";
import PharmacyGroupListComponent from "./PharmacyGroupListComponent.vue";
import ChatButtonComponent from "../Layout/ChatButtonComponent.vue";
import qs from 'qs';
import axios from '../../plugins/axios.ts';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    identityId:{
      type:Number,
      required:true,
    },
    orderPackValues:{
      type:Array,
      default: () => {
          return [];
      }
    },
    submit:{
      type:Function,
    },
    close:{
      type:Function,
    },
    isSp:{
      type:Boolean,
      default: () => {
        return false;
      },
    },
});

const orderPackDataTmp = reactive(initialOrderPackData());
const onAmountFloatTypeChange = (value,label) => {
  orderPackDataTmp.amount_float_type = value;
}
const onTaxTotalTypeChange = (value,label) => {
  orderPackDataTmp.tax_total_type = value;
}
const onAssignmentDateChange = (value) => {
  orderPackDataTmp.assignment_date = value;
  setLastAssignmentDate(value);
}
const onNumberChange = (value) => {
  orderPackDataTmp.number = Number(value);
}
const onPriceChange = (value) => {
  orderPackDataTmp.unit_price = Number(value);
}
const onToPharmacyNoteChange = (value) => {
  orderPackDataTmp.to_pharmacy_note = value;
}
const isPharmacyMedicinePackDialog = ref(false);
const isPharmacyMedicinePackLoading = ref(false);
const orderPackDataDefaultSetting = reactive({
  tax_total_type:0,
  amount_float_type:0,
});
const resetOrderPackDataDefaultSetting = () => {
  orderPackDataTmp.tax_total_type = orderPackDataDefaultSetting.tax_total_type;
  orderPackDataTmp.amount_float_type = orderPackDataDefaultSetting.amount_float_type;
}
const getPharmacyPackDetail = async (commitPharmacy = false,isEdited = false) => {
  targetPharmacyMedicine.splice(0);
  targetPharmacy.splice(0);
  isPharmacyMedicinePackLoading.value = true;
  let params = {'medicine_id': orderPackDataTmp.medicine.id,'target_pharmacy_id':(typeof orderPackDataTmp.pharmacy !== 'undefined' ? orderPackDataTmp.pharmacy.id : 0),'medicine_group_id':(orderPackDataTmp.medicine_group_id == null ? '' : orderPackDataTmp.medicine_group_id),'is_pack_number_visible':1};
  if (isPackType.value == 1) {
    params.stock_id = orderPackDataTmp.pharmacy_medicine_id; // pharmacy_stocks.id;
  }
  const paramsSerializer = (params) => qs.stringify(params);
  try {
    const response = await axios.get(props.apis.pharmacy_medicine_detail,{params:params,paramsSerializer});
    orderPackDataDefaultSetting.tax_total_type = response.data.data.tax_total_type;
    orderPackDataDefaultSetting.amount_float_type = response.data.data.amount_float_type;
    //既に編集済みの場合はその情報を使う
    if (orderPackDataTmp.pharmacy_medicine_id == 0) {
      orderPackDataTmp.pharmacy_medicine_id = response.data.data.id;
    }
    orderPackDataTmp.medicine = response.data.data.medicine;
    orderPackDataTmp.tags = deepCopy(response.data.data.tags);
    //編集済みの場合は上書きしない
    if (isEdited == false || commitPharmacy || isPackType.value == 1) {
      orderPackDataTmp.tax_total_type = response.data.data.tax_total_type;
      orderPackDataTmp.amount_float_type = response.data.data.amount_float_type;
      orderPackDataTmp.number = response.data.data.order_number;
      orderPackDataTmp.unit_price = response.data.data.recent_unit_price;
      orderPackDataTmp.to_pharmacy_note = (typeof response.data.data.to_pharmacy_note !== 'undefined' ? response.data.data.to_pharmacy_note : ''); //取引情報にメモはないのでこの値は無い場合あり
      orderPackDataTmp.medicine_group_name = response.data.data.medicine_group_name;
      if (typeof response.data.data.to_pharmacy !== 'undefined' && response.data.data.to_pharmacy != null) {
        orderPackDataTmp.pharmacy = response.data.data.to_pharmacy
      }
    }
    if (typeof orderPackDataTmp.pharmacy !== 'undefined' && orderPackDataTmp.pharmacy != null && orderPackDataTmp.pharmacy.id) {
      targetPharmacy.push(orderPackDataTmp.pharmacy);
    }
    targetPharmacyMedicine.push(response.data.data);
  } finally {
    isPharmacyMedicinePackLoading.value = false;
  }
}
//isPackType 0：発注 1:受注
const isPackType = ref(0);
const showPharmacyMedicinePack = async (id,medicineId,isPackTypeValue,medicineGroupId,medicineGroupName,pharmacy) => {
  isPackType.value = isPackTypeValue;
  pharmacyRelationOptions.medicine_id = medicineId;
  //一旦リセット
  let defaultOrderPackData = initialOrderPackData();
  if (isPackType.value == 0) {
    defaultOrderPackData = (typeof medicineGroupId === 'undefined' ? initialOrderPackData() : getOrderPackData(id,medicineGroupId,pharmacy.id));
  } else {
    defaultOrderPackData.pharmacy_medicine_id = id; // phamracy_stocks.id
    defaultOrderPackData.medicine_group_id = medicineGroupId;
    defaultOrderPackData.medicine_group_name = medicineGroupName;
    defaultOrderPackData.pharmacy = pharmacy;
  }
  for(let key in defaultOrderPackData) {
    orderPackDataTmp[key] = defaultOrderPackData[key];
  }
  if (typeof orderPackDataTmp.medicine.id === 'undefined') {
    orderPackDataTmp.medicine = {id:medicineId};
  }
  getPharmacyPackDetail(false,(typeof medicineGroupId === 'undefined' ? false : true));
  isPharmacyMedicinePackDialog.value = true;
}
const closePharmacyMedicinePack = () => {
  if (typeof props.close !== 'undefined') {
    props.close();
  }
}
const orderPharmacyMedicinePack = async () => {
  if (orderPackDataTmp.assignment_date.length == 0) {
    errorAlert('譲受譲渡日を指定してください。');
    return;
  }
  if (orderPackDataTmp.number == 0) {
    errorAlert('購入数を指定してください。');
    return;
  }
  if (orderPackDataTmp.number < 0) {
    errorAlert('購入数は正の数字を入力してください。');
    return;
  }
  if (orderPackDataTmp.unit_price == 0) {
    errorAlert('単価を指定してください。');
    return;
  }
  if (targetPharmacyMedicine.length == 0) {
    errorAlert('採用品を指定してください。');
    return;
  }
  await updatePharmacyRelationSetting();
}
const updatePharmacyRelationSetting = async () => {
  let params = new FormData();
  params.append('target_pharmacy_id', (typeof orderPackDataTmp.pharmacy !== 'undefined' ? orderPackDataTmp.pharmacy.id : 0));
  params.append('medicine_group_id', (orderPackDataTmp.medicine_group_id == null ? '' : orderPackDataTmp.medicine_group_id));
  params.append('amount_float_type', orderPackDataTmp.amount_float_type);
  params.append('tax_total_type', orderPackDataTmp.tax_total_type);
  params.append('number', orderPackDataTmp.number);
  params.append('unit_price', orderPackDataTmp.unit_price);
  params.append('medicine_id', orderPackDataTmp.medicine.id);
  params.append('is_new_only', 1);
  isPharmacyMedicinePackLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_relation_setting_update,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.submit !== 'undefined') {
        //オブジェクトのコピーを渡さないと次に初期化した際に親のリストの初期化されてしまうのでコピーを渡す
        props.submit(deepCopy(orderPackDataTmp));
      }
      if (typeof props.close !== 'undefined') {
        props.close();
      }
    }
  } finally {
    isPharmacyMedicinePackLoading.value = false;
  }
}
const getOrderPackData = (pharmacyMedicineId,medicineGroupId,pharmacyId) => {
  let result = initialOrderPackData();
  for (let i=0;i<props.orderPackValues.length;i++) {
    if ((props.orderPackValues[i].pharmacy_medicine_id == pharmacyMedicineId) && (props.orderPackValues[i].medicine_group_id == medicineGroupId) && (props.orderPackValues[i].pharmacy.id == pharmacyId)) {
      result = props.orderPackValues[i];
      break;
    }
  }
  return result;
}

const isTargetPharmacyDialog = ref(false);
const targetPharmacyMedicine = reactive([]);
const targetPharmacy = reactive([]);
const showTargetPharmacyDialog = async () => {
  isTargetPharmacyDialog.value = true;
}
const closeTargetPharmacyDialog = () => {
  isTargetPharmacyDialog.value = false;
}
const commitPharmacy = (item:Object,groupId,groupName) => {
  orderPackDataTmp.pharmacy = item;
  orderPackDataTmp.medicine_group_name = groupName;
  orderPackDataTmp.medicine_group_id = groupId;
  closeTargetPharmacyDialog();
  getPharmacyPackDetail(true);
}
const pharmacyRelationOptions = reactive({
  page_size:30,
  medicine_id:0
});
const commitPharmacyHistory = (item) => {
  if (item.pharmacy == null) {
    errorAlert('薬局データが存在しないため選択出来ません。');
    return;
  }
  orderPackDataTmp.pharmacy = item.pharmacy;
  orderPackDataTmp.medicine_group_name = item.medicine_group_name;
  orderPackDataTmp.medicine_group_id = item.medicine_group_id;
  closeTargetPharmacyDialog();
  getPharmacyPackDetail(true);
}

onMounted(() => {
  let record = initialOrderPackData();
  for (let key in record) {
    orderPackDataTmp[key] = record[key];
  }
})

defineExpose({
  showPharmacyMedicinePack,
  getOrderPackData,
  orderPharmacyMedicinePack,
});
</script>

<style scoped>
</style>
<template>
<div class="border border-gray-300 p-2">
  <div class="border border-gray-300 p-1 flex flex-col justify-items-start" v-for="pharmacy_medicine in targetPharmacyMedicine" :key="pharmacy_medicine.id">
    <div class="w-full m-1 whitespace-pre-wrap">
      <span v-show="isSp == false">{{ pharmacy_medicine.medicine.product_name + ' ' + pharmacy_medicine.medicine.package_label }} </span>最終入出庫：{{ pharmacy_medicine.latest_access_date }}
    </div>
    <div class="w-full m-1">
      製造販売会社：{{ pharmacy_medicine.medicine.manufacturer_name }}
    </div>
    <div class="w-full m-1">
      使用期限：{{ pharmacy_medicine.medicine.transitional_measure_date }}
    </div>
    <div class="w-full m-1">
      実在庫数：{{ pharmacy_medicine.real_stock_number.toLocaleString() + ' ' + pharmacy_medicine.medicine.package_unit }} 仮在庫数：{{ pharmacy_medicine.stock_number.toLocaleString() + ' ' + pharmacy_medicine.medicine.package_unit }}
    </div>
  </div>
</div>
<div class="border p-2 flex flex-col md:flex-row items-center">
  <div v-show="isPackType == 0" class="m-1">
    <button type="button" @click="showTargetPharmacyDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">取引先薬局選択</button>
  </div>
  <div class="m-1 w-full">
    <div class="p-1" v-for="pharmacy in targetPharmacy" :key="pharmacy.id">
      <div class="flex flex-row items-center">
        <div class="m-1">
          <div class="flex flex-row items-center">
            <div>{{ orderPackDataTmp.medicine_group_name + ' ' + pharmacy.pharmacy_name }}</div>
            <div v-show="isSp == false && orderPackDataTmp.medicine_group_id != -1">
              <chat-button-component
              :apis="apis"
              :target-pharmacy="pharmacy"
              ></chat-button-component>
            </div>
          </div>
        </div>
        <a v-show="isSp == false && pharmacy.establish_permit_url.length > 0" :href="pharmacy.establish_permit_url" target="blank" class="block cursor-pointer text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-4 py-1 w-full sm:w-auto text-center ml-2">開設許可証</a>
      </div>
      <div>開設許可証番号：{{ pharmacy.establish_permit_number }}</div>
      <div>開設許可証有効期限：{{ pharmacy.establish_permit_expire_date }}</div>
      <div>住所:{{ pharmacy.pharmacy_prefecture + pharmacy.pharmacy_address + ' ' + pharmacy.pharmacy_address_detail }}</div>
      <div>TEL:{{ pharmacy.pharmacy_telephone }} FAX:{{ pharmacy.pharmacy_fax }}</div>
      <div>営業時間：<span class="crlf-area">{{ pharmacy.pharmacy_business_hour }}</span></div>
    </div>
  </div>
</div>
<div v-show="(typeof orderPackDataTmp.pharmacy !== 'undefined') && (typeof orderPackDataTmp.pharmacy.id !== 'undefined')" class="border p-2 flex flex-col md:flex-row items-center">
  <div class="p-1 flex flex-col justify-items-start" v-for="pharmacy_medicine in targetPharmacyMedicine" :key="pharmacy_medicine.id">
    <div class="m-1 flex flex-col md:flex-row items-center">
      <div class="m-1 mb-1 md:mb-0 w-full md:w-1/2 flex flex-row items-center">
        <div>合計金額条件：</div>
        <div>
          <div v-if="isPackType == 1">
            <span class="border rounded px-2 py-1">{{ pharmacy_medicine.tax_total_type_label }}</span>
          </div>
          <div v-else>
            <select-box
              :value="orderPackDataTmp.tax_total_type"
              :options="config.TAX_TOTAL_TYPES"
              width="280px"
              :on-change="onTaxTotalTypeChange"
            ></select-box>
          </div>
        </div>
      </div>
      <div class="m-1 w-full md:w-1/2 flex flex-row items-center">
        <div>小数点の扱い：</div>
        <div>
          <div v-if="isPackType == 1">
            <span class="border rounded px-2 py-1">{{ pharmacy_medicine.amount_float_type_label }}</span>
          </div>
          <div v-else>
            <select-box
              :value="orderPackDataTmp.amount_float_type"
              :options="config.AMOUNT_FLOAT_TYPES"
              :on-change="onAmountFloatTypeChange"
            ></select-box>
          </div>
        </div>
        <div v-show="isPackType == 0" class="ml-1">
          <a href="javascript:void(0)" @click="resetOrderPackDataDefaultSetting"><i class="fa-solid fa-rotate-left"></i></a>
        </div>
      </div>
    </div>
    <div class="m-1">
      <div class="m-1 flex flex-row items-center">
        <div class="m-1">譲受譲渡日：</div>
        <div v-if="isPackType == 0" class="m-1">
          <text-box
            :value="orderPackDataTmp.assignment_date"
            type="date"
            :on-change="onAssignmentDateChange"
          ></text-box>
        </div>
        <div v-else class="m-1">
          {{ orderPackDataTmp.assignment_date }}
        </div>
      </div>
    </div>
    <div v-if="(orderPackDataTmp.medicine_group_id !== '' && orderPackDataTmp.medicine_group_id === 0) || orderPackDataTmp.pharmacy.pack_number_visible_type == config.PACK_NUMBER_VISIBLE_TYPE['表示する']" class="m-1">
      <div class="m-1 flex flex-row items-center">
        <div v-show="isPackType == 0" class="m-1">在庫数：{{ pharmacy_medicine.target_pharmacy_stock.real_stock_number.toLocaleString() + pharmacy_medicine.medicine.package_unit }}</div>
        <div v-show="isPackType == 0" class="m-1">最終入出庫：{{ pharmacy_medicine.target_pharmacy_stock.latest_access_date }}</div>
        <div v-show="isPackType == 0 && pharmacy_medicine.target_pharmacy_stock.pharmacy_pack_cancel_count > 0" class="m-1 text-white bg-red-700 px-2 rounted">取引キャンセル回数：{{ pharmacy_medicine.target_pharmacy_stock.pharmacy_pack_cancel_count }}</div>
      </div>
    </div>
    <div class="m-1">
      <div class="m-1 flex flex-col md:flex-row items-center">
        <div class="w-full md:w-1/3 flex flex-row items-center">
          <div class="m-1">単価：</div>
          <div v-if="isPackType == 0" class="m-1">
            <text-box
              :value="orderPackDataTmp.unit_price"
              :is-focus-clear="true"
              type="number"
              :on-change="onPriceChange"
            ></text-box>
          </div>
          <div v-else class="m-1">
            \{{ orderPackDataTmp.unit_price.toLocaleString() }}
          </div>
        </div>
        <div class="w-full md:w-1/3 flex flex-row items-center">
          <div class="m-1">
            購入数：
          </div>
          <div v-if="isPackType == 0" class="m-1">
            <text-box
              :value="orderPackDataTmp.number"
              :is-focus-clear="true"
              type="number"
              :on-change="onNumberChange"
            ></text-box>
          </div>
          <div v-else class="m-1">
            {{ orderPackDataTmp.number.toLocaleString() }}
          </div>
          <div class="m-1">{{ pharmacy_medicine.medicine.package_unit }}</div>
        </div>
        <div class="w-full md:w-1/3 flex flex-row items-center">
          <div class="m-1">
            取引メモ：
          </div>
          <div v-if="isPackType == 0" class="m-1">
            <text-box
              :value="orderPackDataTmp.to_pharmacy_note"
              :is-focus-clear="false"
              type="textarea"
              :on-change="onToPharmacyNoteChange"
              :text-area-rows="2"
            ></text-box>
          </div>
          <div v-else class="m-1 crlf-area">
            {{ orderPackDataTmp.to_pharmacy_note }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div v-show="isPackType == 0 && isSp == false" class="flex">
  <div class="flex-row mr-2">
    <button type="button" @click="orderPharmacyMedicinePack" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
  </div>
  <div class="flex-row">
    <button type="button" @click="closePharmacyMedicinePack" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
  </div>
</div>

<modal-dialog
  :is-visible="isTargetPharmacyDialog"
  :close="closeTargetPharmacyDialog"
>
  <template v-slot:header>
    取引先薬局選択
  </template>
  <template v-slot:default>
    <div class="mb-6">
      <span class="text-sm">現在在庫のある過去の取引先</span>
      <custom-list
        ref="listPharmacyRelationRef"
        :option-fields="pharmacyRelationOptions"
        :api-url="apis.pharmacy_relation_history_list"
        height="100px"
        width="100%"
      >
      <template v-slot:item="slotProps">
        <div class="w-full flex items-center justify-between" @click="commitPharmacyHistory(slotProps.item)">{{ slotProps.item.medicine_group_name }} {{ slotProps.item.pharmacy_name }}({{ slotProps.item.pharmacy_prefecture }})<div v-show="slotProps.item.pharmacy.old_medicine_count > 0"> <img class="w-6 h-6" src="../../../public/images/icon/icon_old_medicine_alert.png"></div></div>
      </template>
      </custom-list>
      <pharmacy-group-list-component
        :apis="apis"
        type="is_pack"
        :medicine-id="(typeof orderPackDataTmp.medicine !== 'undefined' ? orderPackDataTmp.medicine.id : 0)"
        :on-select-pharmacy="commitPharmacy"
      ></pharmacy-group-list-component>
    </div>
  </template>
</modal-dialog>
<modal-dialog
  :is-visible="isPharmacyMedicinePackLoading"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>
</template>

